var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"text-button",attrs:{"rounded":"","x-large":"","color":"primary","loading":_vm.loading,"disabled":_vm.disabled || _vm.loading},domProps:{"textContent":_vm._s(_vm.$t('markAsReady'))},on:{"click":_vm.markReadyButton}})}
var staticRenderFns = []

export { render, staticRenderFns }